import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// Constants
import { REPORT_TRANSACTION_SORT_DATE_FILTER } from 'common/constants/filters'

// Assets
import { FilterIcon } from 'assets/images/Icons'

// Store
import { actions } from 'core/store'

// Styled Elements
import { TableFilterFormWrapper, DropwdownFilterWrapper, Divider } from '../Filter.elements'

// Components
import { SimpleSelect, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DateRangePicker } from 'views/components'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = (dispatch) => actions(dispatch)

function ReportsTransactionTableFilter(props) {
  // Destructure
  const { filters, actions } = props
  const { reportsTransactionFilters } = filters
  const { sort, start_range, end_range } = reportsTransactionFilters

  // Store Actions
  const { setReportsTransactionFilters } = actions

  // Functions
  // Filter Functions
  const handleDateSelect = async ({ start, end }) => {
    await setReportsTransactionFilters({
      ...reportsTransactionFilters,
      start_range: start,
      end_range: end,
    })
  }
  const handleSortSelect = async (value) => {
    if (sort !== value) {
      await setReportsTransactionFilters({ ...reportsTransactionFilters, sort: value })
    }
  }

  return (
    <TableFilterFormWrapper>
      <UncontrolledDropdown direction="down">
        <DropdownToggle>
          <Button
            variant="outlined"
            size="small"
            startIcon={<FilterIcon size={14} />}
          >
            Filter
          </Button>
        </DropdownToggle>
        <DropdownMenu style={{ minWidth: '300px' }}>
          <DropwdownFilterWrapper>
            <DateRangePicker
              id="TransactionDateFilter"
              onApply={handleDateSelect}
              start={start_range}
              end={end_range}
              style={{ minWidth: '300px' }}
            />

            <Divider />

            <SimpleSelect
              label="Sort By: "
              options={REPORT_TRANSACTION_SORT_DATE_FILTER}
              onChange={handleSortSelect}
              value={sort}
            />
          </DropwdownFilterWrapper>
        </DropdownMenu>
      </UncontrolledDropdown>
    </TableFilterFormWrapper>
  )
}

// Default Props
ReportsTransactionTableFilter.defaultProps = {
  filters: {},
  actions: {},
}

// Proptypes Validation
ReportsTransactionTableFilter.propTypes = {
  filters: PropTypes.shape({
    reportsTransactionFilters: PropTypes.shape({
      sort: PropTypes.string,
      account_type_id: PropTypes.number,
      page_index: PropTypes.number,
      start_range: PropTypes.string,
      end_range: PropTypes.string,
    }),
  }),
  actions: PropTypes.shape({
    setShowHeaderLoader: PropTypes.func,
    setReportsTransactionFilters: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportsTransactionTableFilter)
